import factoryLogger from '../../logger/index.js'
import HTTPI18nRepository from '../Repositories/HTTPI18nRepository.js'
import I18nValueObjectsFactory from '../ValueObjects/factory.js'

export default class I18nRepositoriesFactory {
  static hTTPI18nRepository = () =>
    new HTTPI18nRepository({
      valueObject: I18nValueObjectsFactory.i18nLiteralsValueObject,
      log: factoryLogger({prefix: 'HTTPI18nRepository'})
    })
}
